import { useState } from 'react';
import { Button } from '../Button';
import { getSsoUrl } from '../../config/environment';
import { AnimatedLogos } from './AnimatedLogos';

interface SSOLoginProps {
  onLoading?: (loading: boolean) => void;
}

export const SSOLogin = ({ onLoading }: SSOLoginProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleMicrosoftLogin = () => {
    setIsLoading(true);
    if (onLoading) onLoading(true);
    
    // Redirecionar para o backend SSO (usa configuração automática de ambiente)
    window.location.href = getSsoUrl();
  };

  return (
    <div className="space-y-4">
      <Button
        type="button"
        variant="outline"
        onClick={handleMicrosoftLogin}
        disabled={isLoading}
        className="w-full flex items-center justify-between pl-9 space-x-3 py-6 h-20"
      >
        <span className="text-base font-medium">
          {isLoading ? 'Redirecionando...' : 'Entre com seu e-mail institucional'}
        </span>
        <AnimatedLogos/>
      </Button>
    </div>
  );
};